import useApi, { ApiOptions } from '../base/useApi';
import CardHeaderDTO from '@src/adapters/dto/card/CardHeaderDTO';
import CardFilterDTO from '@src/adapters/dto/card/CardFilterDTO';

interface Params {
  filter: CardFilterDTO;
}

interface Result {
  cards: CardHeaderDTO[];
  recordCount: number;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/card/find',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useGetCardsLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useGetCardsLazy;
